import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const DESTINATIONS = [
  { label: 'Get Renovation Quotes', to: '/get-renovation-quotes', note: 'For homeowners' },
  { label: 'Get Qualified Leads', to: '/contractors/get-qualified-leads', note: 'For contractors' },
  { label: 'Grow My Business', to: '/contractors/grow-your-business', note: 'For contractors' },
  { label: 'Contact HyenaMind', to: '/contact', note: 'Talk to our team' },
];

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | HyenaMind" description="The page you are looking for is not available. Find renovation quotes, contractor leads or contact HyenaMind." path="/404" noindex />
      <section className="dark-section min-h-screen flex items-center pt-28 pb-20" data-testid="not-found-page">
        <div className="container-site">
          <p className="overline-tag text-steel-light"><span className="h-px w-8 bg-steel-light" />Error 404</p>
          <h1 className="mt-6 font-display text-6xl sm:text-8xl tracking-tighter leading-none font-medium text-bone">
            This page went <span className="text-steel-light">off-site.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-silver">
      The page you are looking for is not available. It may have moved or never existed. Here is where most
            people were headed:
          </p>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
            {DESTINATIONS.map((d) => (
              <Link
                key={d.to}
                to={d.to}
                data-testid={`404-link-${d.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="group flex items-center justify-between gap-3 border border-white/12 rounded-md px-6 py-5 transition-all duration-300 hover:border-steel-light/60 hover:bg-white/[0.04]"
              >
                <span>
                  <span className="block text-xs font-bold uppercase tracking-[0.16em] text-steel-light">{d.note}</span>
                  <span className="mt-1 block font-display text-lg font-medium text-bone">{d.label}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 text-bone/60 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            ))}
          </div>
          <Link to="/" data-testid="404-home-link" className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-silver hover:text-bone transition-colors">
            ← Back to the homepage
          </Link>
        </div>
      </section>
    </>
  );
}
